import { inject } from '@angular/core';
import { LoggingService } from '../logging/logging.service';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';

export const SplashGuardService = () => {
    const loggingService = inject(LoggingService);
    const splashScreenStateService = inject(SplashScreenStateService);
    const log = loggingService.getLogger(SplashGuardService.name);

    log.debug('canActivate()');
    splashScreenStateService.stop();
    return true;
};
